import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
} from "@mui/material";

import SiteLink from "../Shared/SiteLink";

import PropTypes from "prop-types";

import { useFlags } from "launchdarkly-react-client-sdk";

import { useSearchParams } from "react-router-dom";

const AssetTable = ({ type, list, manufacturerLookup = {}, modelLookup = {} }) => {
  const flags = useFlags();
  const [searchParams] = useSearchParams();
  const demoMode = flags.portfolioDemoMode || searchParams.get("mode") === "demo";

  const calculateTotalPowerCapacity = () => {
    let cap = 0;
    list.forEach((item) => {
      cap = cap + (item.power_capacity || 0);
    });
    return Math.round(cap);
  };

  const calculateTotalEnergyCapacity = () => {
    let cap = 0;
    list.forEach((item) => {
      cap = cap + (item.energy_capacity || 0);
    });
    return Math.round(cap);
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Site</TableCell>
            <TableCell>Asset</TableCell>
            <TableCell>Manufacturer</TableCell>
            <TableCell>Model</TableCell>
            {type === "bess" ? (
              <>
                <TableCell align="right">Nameplate Power (kW)</TableCell>
                <TableCell align="right">Nameplate Capacity (kWh)</TableCell>
              </>
            ) : (
              <TableCell align="right">Nameplate Power (kW)</TableCell>
            )}
            {type === "genset" ? <TableCell align="right">Genset Use</TableCell> : null}
            {demoMode ? <TableCell align="right">Programs</TableCell> : null}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>
              <Typography variant="subtitle1" color="secondary">
                Totals
              </Typography>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>

            {type === "bess" ? (
              <>
                <TableCell align="right">
                  <Typography variant="subtitle1" color="secondary">
                    {calculateTotalPowerCapacity().toLocaleString()} kW
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="subtitle1" color="secondary">
                    {calculateTotalEnergyCapacity().toLocaleString()} kWh
                  </Typography>
                </TableCell>
              </>
            ) : (
              <TableCell align="right">
                <Typography variant="subtitle1" color="secondary">
                  {calculateTotalPowerCapacity().toLocaleString() + " kW"}
                </Typography>
              </TableCell>
            )}
            {type === "genset" ? <TableCell></TableCell> : null}
            {demoMode ? <TableCell></TableCell> : null}
          </TableRow>
          {list.map((item) => (
            <TableRow key={item.uuid} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell>
                <SiteLink
                  variant="subtitle1"
                  color="grey"
                  site={{ name: item.site_name, uuid: item.site_uuid }}
                />
              </TableCell>
              <TableCell scope="row">
                <Typography color="grey">
                  {item.name}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="grey">
                  {manufacturerLookup[item.manufacturer] || item.manufacturer || "—"}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="grey">
                  {modelLookup[item.model] || item.model || "—"}
                </Typography>
              </TableCell>
              {type === "bess" ? (
                <>
                  <TableCell align="right">
                    <Typography color="grey">
                      {isNaN(Math.round(item.power_capacity))
                        ? "N/A"
                        : Math.round(item.power_capacity).toLocaleString()}{" "}
                      kW
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography color="grey">
                      {isNaN(Math.round(item.energy_capacity))
                        ? "N/A"
                        : Math.round(item.energy_capacity).toLocaleString()}{" "}
                      kWh
                    </Typography>
                  </TableCell>
                </>
              ) : (
                <TableCell align="right">
                  <Typography color="grey">
                    {isNaN(Math.round(item.power_capacity))
                      ? " N/A "
                      : Math.round(item.power_capacity).toLocaleString()}
                    {" "}kW
                  </Typography>
                </TableCell>
              )}
              {type === "genset" ? (
                <TableCell align="right">
                  <Typography color="grey">
                    {item.genset_use || "—"}
                  </Typography>
                </TableCell>
              ) : null}
              {demoMode ? (
                <TableCell align="right">
                  {type === "bess" ? (
                    <>
                      <Chip color="lightGrey" label="PDR" />
                      <Chip color="lightGrey" label="ELRP" />
                    </>
                  ) : null}
                </TableCell>
              ) : null}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

AssetTable.propTypes = {
  type: PropTypes.string,
  list: PropTypes.array,
  synthetic: PropTypes.bool,
};

export default AssetTable;
